/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React from 'react';
import { colors } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DashboardIcon from '@mui/icons-material/DashboardOutlined';

import { Label } from 'components';

import config from '../../../../configuration/configuration.js';

export default [
	{
		title: '',
		pages: [
			{
				title: 'Home',
				href: '/home',
				icon: HomeIcon,
				// roles: ['Administrator', ...]
				// projects: ['Operations'],
			},
		],
	},
	{
		title: 'Projects',
		pages: [
			{
				title: 'London Underground',
				children: [
					{
						title: 'Kpis',
						href: '/kpis',
						icon: ShowChartIcon,
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						// projects: ['Operations'],
						children: [
							{
								title: 'Reports',
								href: '/kpis/LU/reports',
							},
							// {
							// 	title: 'Weekly Report',
							// 	href: '/kpis/LU/weeklyReport'
							// }
						],
					},
					// {
					// 	title: 'Nomination Form',
					// 	href: 'menu/nominationForm',
					// 	roles: ['Administrator'],
					// 	icon: PictureAsPdfIcon
					// },
					// {
					// 	title: 'Incident Tracker',
					// 	href: '/trackers/IncidentTracker',
					// 	roles: ['Administrator'],
					// 	icon: TrackChangesIcon
					// },
					{
						title: 'Site Tracker',
						href: '/trackers/SiteTracker',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						icon: BarChartIcon
					},
					{
						title: 'Dashboards',
						href: '/dashboards',
						icon: DashboardIcon,
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						children: [
							{
								title: 'Rollout',
								href: '/dashboards/LU/rollout',
							},
							{
								title: 'Weekly Report',
								href: '/dashboards/LU/weeklyReportDashboard',
							},
							{
								title: 'KPIs Global Hourly',
								href: '/dashboards/LU/kpisGlobalDashboardHourly',
							},
							{
								title: 'KPIs Global Daily',
								href: '/dashboards/LU/kpisGlobalDashboardDaily',
							},
						],
					},
					{
						title: 'Dashboards',
						href: '/dashboards',
						icon: DashboardIcon,
						roles: ['Client'],
						children: [
							{
								title: 'Weekly Report',
								href: '/dashboards/LU/weeklyReportDashboard',
							},
						],
					}
				]
			},
			{
				title: 'Streetscape',
				children: [
					{
						title: 'Kpis',
						href: '/kpis',
						icon: ShowChartIcon,
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						// projects: ['Operations'],
						children: [
							{
								title: 'Reports',
								href: '/kpis/SS/reports',
							}
						],
					},
					{
						title: 'StreetScape Tracker',
						href: '/trackers/StreetScapeTracker',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						icon: BarChartIcon
					},
					{
						title: 'Dashboards',
						href: '/dashboards',
						icon: DashboardIcon,
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						children: [
							{
								title: 'Rollout',
								href: '/dashboards/SS/rollout',
							},
							{
								title: 'Weekly Report',
								href: '/dashboards/SS/weeklyReportDashboard',
							},
							{
								title: 'KPIs Global Hourly',
								href: '/dashboards/SS/kpisGlobalDashboardHourly',
							},
							{
								title: 'KPIs Global Daily',
								href: '/dashboards/SS/kpisGlobalDashboardDaily',
							},
						],
					},
					{
						title: 'Dashboards',
						href: '/dashboards',
						icon: DashboardIcon,
						roles: ['Client'],
						children: [
							{
								title: 'Weekly Report',
								href: '/dashboards/SS/weeklyReportDashboard',
							},
						],
					}
				]
			}
		]
	},
	{
		title: 'Management',
		pages: [
			{
				title: 'Manage',
				href: '/management',
				roles: ['Administrator', 'Manager'],
				icon: SupervisorAccountIcon,
				children: [
					{
						title: 'Operators',
						href: '/management/operators',
					},
					{
						title: 'Users',
						href: '/management/users',
					}
				],
			},
			{
				title: 'Hangfire',
				href: `${config.API_URL}hangfire?access_token={token}`,
				target: '_blank',
				roles: ['Administrator'],
				icon: DesktopMacIcon
			},
			{
				title: 'Settings',
				href: '/management/settings',
				icon: SettingsIcon
			},
		],
	}
];
